import React from "react";
import Header from "./Header";
import { Outlet } from "react-router-dom";

// Портал бүрхүүл: дээд бар + (мобайл) доод таб — зайг .app-content тооцно
function Layout() {
  return (
    <div className="relative flex flex-col min-h-screen bg-[#f4f5f9]">
      <Header />
      <main id="body" className="app-content w-full max-w-6xl mx-auto px-4 md:px-6">
        <Outlet />
      </main>
    </div>
  );
}

export default Layout;
